module.exports = __webpack_public_path__ + "img/moneygun2.6fdc5ec7.png";